module.exports = __webpack_public_path__ + "img/icon-pencil.7fa45bcf.svg";